import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { LanguageType } from '@/i18n'
import { SelectedLanguage } from '@/models/local-storage'

/**
 * 選んだ言語は i18n の languageChanged で保存しているが、再読み込み時は既定言語で初期化されるため、画面側で戻す。
 * 同じ端末の別画面（セルフチェックイン等）で選ばれた言語も同じキーに入るため、その画面が選択肢に出している言語だけを戻す。
 */
export const useRestoreLanguage = (languages: readonly LanguageType[]): void => {
  const { i18n } = useTranslation()

  // 再読み込み直後に1回だけ戻す。以降の切り替えは利用者の操作に任せる
  useEffect(() => {
    let stored: string | null
    try {
      stored = localStorage.getItem(SelectedLanguage)
    } catch {
      // localStorage 自体が使えない環境（プライベートブラウズ等）では既定言語のまま続行する
      return
    }

    const language = languages.find(target => target === stored)
    if (language && language !== i18n.language) {
      i18n.changeLanguage(language)
    }
  }, [])
}
